module.exports = __webpack_public_path__ + "media/images/meta/akt/apple-touch-icon_alt-219cfe3603b2e6dd2785fdd0659e169b.png";